// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"0b5754254fc6be95af16","883":"19fdc4c1f7f7d67feb33"}[chunkId] + ".js";
};